export default __webpack_public_path__ + "assets/pdf/Resume_Jay.pdf";